var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTransparent = function SvgAlertTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    stroke: "transparent",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12.002 9v4m0 4v.01m-6.994 3.986h13.987c2.315 0 3.758-2.511 2.592-4.511L14.594 4.49c-1.158-1.986-4.026-1.986-5.184 0L2.417 16.484c-1.166 2 .276 4.51 2.591 4.51M12.252 17a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
  })));
};
export default SvgAlertTransparent;